module.exports = __webpack_public_path__ + "img/post-bank.04b650da.png";